export default "__VITE_ASSET__3691ea0d__"